<template>
  <svg :width="width" :height="height" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12" r="11.25" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M12.5001 14.4C8.6663 14.4 5.37143 16.3746 3.92871 19.2C5.11919 20.6333 8.50015 23.5 12.5001 23.5C16.5001 23.5 19.8811 20.6333 21.0716 19.2C19.6289 16.3746 16.334 14.4 12.5001 14.4Z" :fill="color"/>
    <circle cx="12.5001" cy="8.22863" r="4.45714" :fill="color"/>
  </svg>
</template>

<script>
export default{
  name: 'accountIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '25'
    },
    height: {
      type: [String, Number],
      default: '24'
    }
  }
}</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/AccountIcon.vue